package com.neurobs.ccabserver.translationadmin.components.translationprogress

import com.neurobs.ccabserver.translationadmin.components.translationprogress.components.{TranslatorProgressCard, TranslatorProgressCards, TranslatorSelection}
import com.neurobs.ccabserver.translationadmin.states.TranslationProgressStateGenerator
import com.neurobs.react.ReactUtil
import com.neurobs.react.semanticui.{UiGridFactory, UiLoaderFactory, UiMessageFactory}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

import scala.scalajs.js

@react
object TranslationProgress {

  case class Props()
  val component = FunctionalComponent[Props] { _ =>

    def columnStyle = Seq[(String, js.Any)](("minHeight", "100px"))

    UiGridFactory.Grid(
      TranslatorSelection(
        UiGridFactory.GridColumn(_)("four wide", columnStyle)
      ),
      TranslatorProgressCards(
        UiGridFactory.GridColumn(_)("twelve wide", columnStyle)
      )
    )
  }

}
